import React from 'react';
import { AudienceMetric, getMetricFormatting } from './models/metrics';
import { Divider, Grid, Paper, Typography } from '@mui/material';
import { CardViewTextRow } from 'ui/viewComponents';
import { AudienceCardHeader } from './utils/audiencesUI';

interface SegmentMetricsOverviewProps {
    metrics: AudienceMetric[];
}

export const SegmentMetricsBetaOverview: React.FC<SegmentMetricsOverviewProps> = ({ metrics }) => {
    const renderMetric = React.useCallback((metric: AudienceMetric) => {
        const { title, valueFormatter } = getMetricFormatting(metric.metricId);
        return (
            <Grid
                key={metric.metricId}
                size={{
                    xs: 12,
                    sm: 3,
                    xl: 2
                }}
            >
                <CardViewTextRow noTransform title={title} value={valueFormatter(metric.value)} />
            </Grid>
        );
    }, []);
    return (
        <Paper sx={{ mb: 2, border: '1px solid', borderColor: 'divider' }}>
            <AudienceCardHeader>
                <Typography>Metrics</Typography>
            </AudienceCardHeader>
            <Divider />
            <Grid container spacing={2} sx={{ p: 2 }}>
                {metrics.map(renderMetric)}
            </Grid>
        </Paper>
    );
};
